module.exports = __webpack_public_path__ + "c29828cd1d6a59b6acd7de9d0cd40e6a.svg";